<template lang="pug">
#app.sans-serif(
  ref='top',
  :class=`{
    'in-process': currentStepIndex >= 0 && currentStepIndex < steps.length
  }`
)


  header

    .Topnav


      .logo
        a(
          href='#',
          @click='currentStepIndex = 0'
        )
          img( src='./assets/logo.png', width='100%', alt=siteName )

      .inner

        nav

          .nav-inner

            .TopnavEl.dn.db-ns
              a(href='http://www.bookart.ca/create-book/') Create Book

            .TopnavEl.dn.db-ns
              a(href='http://www.bookart.ca/library/') Library

            .TopnavEl.dn.db-ns
              a(href='http://www.bookart.ca/about/') About

            .TopnavEl.dn.db-ns
              a(href='http://www.bookart.ca/shop/') Shop

      .right-column



  transition( name='fade', mode='out-in' )
    section.Hero.black-90.ph3.mh-5.tc.flex.flex-column.justify-center(
      key='hero',
      v-if='currentStepIndex < 0'
    )
      .Hero-Space
        h1.mb4.mr4.ml4 {{ settings.homeHeader }}
        p.mr4.ml4(v-for="(homeText, idx) of homeTextLines" :key="'line' + idx") {{ homeText }}

        .mt4.ml4.mr4
          a.BottomNavButton.BottomNavButton--fluid(
            href='#',
            @click.prevent='currentStepIndex = 0'
          ) Get started

    section.Hero.black-90.ph3.mh-5.tc.flex.flex-column.justify-center(
      key='success',
      v-if='currentStepIndex === steps.length'
    )
      .Hero-Space.center
        h1.f2.fw2.mb1 {{ settings.submissionHeader }}
        h2.f6.f5-l.fw4(v-html="settings.submissionText")

        .mt5
          a.BottomNavButton.BottomNavButton--fluid(
            href='/',
          ) Make another estimate

    section.Process(
      key='process',
      v-if='currentStepIndex >= 0 && currentStepIndex < steps.length'
    )
      .dn.db-ns(ref='steps-top')
      bookart-steps(
        v-model='currentStepIndex',
        :steps='steps',
        :disabled-options='disabledOptions'
      )

      section.Categories.ph3.ph5-l.mb6.black-90( ref='categories' )
        transition( name='fade', mode='out-in' )
          div( :key='currentStepIndex' )
            bookart-quantities(
              v-model='quantities',
              :settings='settings',
              v-if='currentStepIndex === 0'
            )

            bookart-category(
              v-for='catI in sections.general'
              v-model='categories[catI]',
              @select='selectOption(catI, $event)',
              :selected-option-index='selectedOptions[catI]',
              v-if='currentStepIndex === 0'
            )

            bookart-category(
              v-for='catI in sections.cover'
              v-model='categories[catI]',
              @select='selectOption(catI, $event)',
              :selected-option-index='selectedOptions[catI]',
              v-if='currentStepIndex === 1 && !isCategoryIndexDisabled[catI]'
            )

            bookart-category(
              v-for='catI in sections.paper'
              v-model='categories[catI]',
              @select='selectOption(catI, $event)',
              :selected-option-index='selectedOptions[catI]',
              v-if='currentStepIndex === 2 && !isCategoryIndexDisabled[catI]'
            )

            bookart-review(
              :categories='categories',
              :discounts='discounts',
              :pageprices='pageprices',
              :disabled-options='disabledOptions',
              :quantities='quantities',
              :selected-options='selectedOptions',
              :groups='groups',
              :settings='settings'
              v-if='currentStepIndex === 3'
            )

            bookart-submit(
              ref='submit',
              v-model='projectInfos',
              v-if='currentStepIndex === 4',
              @success='success',
              :settings='settings'
            )

        section.BottomNav.pa2-m.pa4-l.mb5.m.dn.db-ns.tc
          a.BottomNavButton.BottomNavButton--empty(
            href='#',
            @click.prevent='currentStepIndex -= 1'
            v-if='currentStepIndex > 0'
          ) Previous

          a.BottomNavButton(
            href='#',
            @click.prevent='currentStepIndex += 1',
            v-if='currentStepIndex < steps.length - 1'
          ) Next

          a.BottomNavButton.BottomNavButton--submit(
            href='#',
            @click.prevent='submitForm',
            v-if='currentStepIndex === steps.length - 1',
            :class="{ 'disabled': quantities.books < 50 }"
          ) Submit


      bookart-summary(
        v-if="quantities.books > 0",
        :categories='categories',
        :disabled-options='disabledOptions',
        :discounts='discounts',
        :pageprices='pageprices',
        :quantities='quantities',
        :selected-options='selectedOptions',
        :groups='groups',
        :settings='settings'
      )
</template>

<script>

import _ from 'lodash'
import fastClick from 'fastclick'

import BookartCategory from './components/BookartCategory/BookartCategory'
import BookartQuantities from './components/BookartQuantities/BookartQuantities'
import BookartReview from './components/BookartReview/BookartReview'
import BookartSteps from './components/BookartSteps/BookartSteps'
import BookartSubmit from './components/BookartSubmit/BookartSubmit'
import BookartSummary from './components/BookartSummary/BookartSummary'

import { scrollTo, scrollToEl } from './scroll-to-el.js'

export default {
  name: 'app',
  data: () => ({
    categories: [],
    currentStepIndex: -1,
    manualStepChange: false,
    disabledOptions: [],
    discounts: [],
    pageprices: [],
    quantities: {
      books: 50,
      pages: 40,
    },
    selectedOptions: [],
    steps: [
      'General',
      'Binding & Cover',
      'Interior',
      'Review',
      'Send',
    ],
    projectInfos: {
      comments: '',
      copyediting: '0',
      deadline: '',
      designassistance: '0',
      email: '',
      firstname: '',
      lastname: '',
      postal: '',
      prepressassistance: '0',
      publishingsupport: '0',
    },
    settings: {}
  }),

  watch: {
    currentStepIndex () {

      if (this.manualStepChange) {
        this.manualStepChange = false
      } else {
        if (this.currentStepIndex === -1) this.currentStepIndex += 1
        if (this.currentStepIndex === this.steps.length) this.currentStepIndex -= 1
      }

      if (this.currentStepIndex === 4 && this.isTotalInvalid) {
        this.currentStepIndex -= 1
      }

      const stepsTopEl = this.$refs['steps-top']
      if (stepsTopEl) scrollToEl(stepsTopEl, { offset: 1 })

    },
  },

  computed: {
    homeTextLines() {
      return this.settings.homeText && this.settings.homeText.split('\n\n')
    },
    groups () {

      // Create groups for every category and save their indexes
      return this.categories.reduce((groups, cat, catI) => {
        if (!groups[cat.group]) groups[cat.group] = []
        groups[cat.group].push(catI)
        return groups
      }, {})

    },

    sections () {
      // Create sections for every category and save their indexes
      let sections = this.categories.reduce((sections, cat, catI) => {
        if (cat.id === 3) return sections
        if (!sections[cat.section]) sections[cat.section] = []
        sections[cat.section].push(catI)
        return sections
      }, {})

      sections.paper.push(this.categories.findIndex(cat => cat.id === 3))
      return sections
    },

    isCategoryIndexDisabled () {
      return this.categories.map(cat => {
        return cat.options.every(opt => this.disabledOptions.includes(opt.id))
      })
    },

    invalidCategoriesIndexes () {
      return this.categories.reduce((invalidCategoriesIndexes, cat, catI) => {
        const isCategoryDisabled = this.isCategoryIndexDisabled[catI]
        const selectedOptionId = cat.options[this.selectedOptions[catI]].id
        const isSelectedOptionDisabled = this.disabledOptions.includes(selectedOptionId)

        if (!isCategoryDisabled && isSelectedOptionDisabled) {
          invalidCategoriesIndexes.push(catI)
        }
        return invalidCategoriesIndexes
      }, [])
    },

    isTotalInvalid () {
      return (
        this.invalidCategoriesIndexes.length > 0 ||
        this.quantities.books < 50
      )
    },
  },

  methods: {

    selectOption (catI, optionI) {
      this.$set(this.selectedOptions, catI, optionI)
      this.updateDisabledOptions()
    },

    submitForm () {
      if (this.quantities.books < 50) return
      this.$refs.submit.submitForm()
    },

    success () {
      this.manualStepChange = true
      this.currentStepIndex = 5
    },

    updateDisabledOptions () {
      let disabledOptions = new Set()

      for (const [i, category] of this.categories.entries()) {
        const categoryOptionIds = category.options.map(cat => cat.id)

        if (categoryOptionIds.every(id => disabledOptions.has(id))) {
          console.log(`Category ${i} ${category.name} already has all option disabled. Skipping.`)
          continue
        }

        const disabledOptionIds = category.options[this.selectedOptions[i]].disabledOptions
        for (const id of disabledOptionIds) {
          console.log(`Category ${i} ${category.name} has disabled option ${id}`)
          disabledOptions.add(id)
        }
      }

      this.disabledOptions = Array.from(disabledOptions)
    },

  },
  async mounted () {

    fastClick.attach(document.body)

    try {

      const resp = await this.$http.get(`${this.$root.BASE}/api/v1`)

      const data = resp.data.data
      this.categories = data.categories
      this.discounts = data.discounts
      this.pageprices = data.pageprices
      this.settings = data.settings


      // Select the first option of every category by default
      this.selectedOptions = this.categories.map(cat => 0)

      this.updateDisabledOptions()

    } catch (err) {
      console.error('Failed to load API data', err)
    }

  },
  components: {
    BookartCategory,
    BookartQuantities,
    BookartReview,
    BookartSteps,
    BookartSubmit,
    BookartSummary,
  },
}
</script>

<style lang="stylus">

@import url("https://use.typekit.net/xsq0pyy.css");

@import 'styles/vars'
@import './styles/tachyons'

html, body, p, .sans-serif
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 400
  font-style: normal
  font-size: 18px
  letter-spacing: 0.02em
  text-transform:none
  -webkit-font-smoothing: subpixel-antialiased;
  color: #000

.gray
  color:#000

p
  line-height: 1.6em
  font-size: 1rem!important

p.f6
  font-size:0.9rem!important

#app.in-process
  padding-bottom: 7rem

  @media $breakpoints.ns
    padding-bottom: 5rem

$nav-height = 113px

a, a:hover, a:active, a:visited
  color: $black
  text-decoration: underline

h1, .f1
  font-family: neue-haas-grotesk-display;
  font-weight: 200;
  font-style: normal;
  font-size: 64px;
  letter-spacing: .03em;
  line-height: 1em;
  text-transform: none;

h2, .f3-l
  font-family: neue-haas-grotesk-display;
  font-weight: 200;
  font-style: normal;
  font-size: 24px;
  letter-spacing: .06em;
  line-height: 1.2em;
  text-transform: none;

.Topnav
  box-sizing: border-box
  transition: .3s height
  box-sizing: border-box;
  padding-left: 31px;
  padding-right: 31px;
  padding-top:26px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items:center;
  margin-bottom:20px;


  .logo
    position:relative
    justify-content: left
    align-items: left
    display: flex
    -webkit-box-flex: 1;
    -ms-flex: 1 1 0px;
    -webkit-flex: 1 1 0px;
    flex: 1 1 0px;
    padding: 7.5px 8px;

    img
      max-width: 245px;

    //flex: 0 0 100%; /* Let it fill the entire space horizontally */



  .inner

    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    display: flex
    -webkit-box-flex: 1;
    -ms-flex: 0 0 auto;
    -webkit-flex: 0 0 auto;
    flex: 0 0 auto;

    //@media $breakpoints.l
    //transform: translateX(-19px)

    height:31px;
    //margin-top:15px;
    margin-top: -2px;
    margin-left: -16px;


    nav
      -webkit-box-ordinal-group: 2;
      -ms-flex-order: 2;
      -webkit-order: 2;
      order: 2;
      padding: 7.5px 8px;
      white-space: nowrap;
      line-height: 1em;
      white-space: nowrap;
      line-height: 1em;
      flex: 0 0 auto;
      .nav-inner
        margin: -.618em -1.38em;

  .right-column
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 0px;
    -webkit-flex: 1 1 0px;
    flex: 1 1 0px;
    text-align: right;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;

.TopnavEl
  margin: 0 1.38em
  padding: .618em 0
  display: inline-block
  vertical-align: middle

  &.TopnavEl--big
    margin: 0 35px

  a
    text-decoration: none
    font-weight: 500
    font-style: normal
    font-size: 16px
    letter-spacing: 0.03em
    text-transform: none
    color: #000

/* Hero style */


.Hero
  //height: 'calc(100vh - %s)' % $nav-height

.Hero-Space
  margin: 2rem auto
  max-width:550px;
  //transform: translateY(-11vh)
  text-align:left


/* Page transitions */

.fade
  &-enter-active, &-leave-active
    transition: all .3s

  &-enter, &-leave-to
    opacity: 0

/*.button-group a
  border: 1px solid
  @extend .b--lavender

  &:not(:last-child)
    border-right: none

  &:hover
    @extend .b--lavender*/

/* Bottom-nav */

a.BottomNavButton
  font-family: neue-haas-grotesk-text, sans-serif
  font-weight:400
  width: 150px
  max-width: 100%
  line-height:1.4em

  box-sizing: border-box
  display: inline-block
  padding: .5em 1.25em

  border: 1px solid $lavender
  background-color: $lavender

  font-size: 1.2rem
  text-transform: none
  text-align: center
  text-decoration: none
  letter-spacing: 0.03em
  color: white

  transition: opacity 0.15s ease-in-out

  &.BottomNavButton--fluid
    width: auto

  &.BottomNavButton--empty
    background: white
    color: $lavender

  &.BottomNavButton--submit
    background: rgb(75, 198, 62)
    border-color: @background
    color: white

    &.disabled
      background: #cdcdcd
      border-color: @background
      color: rgb(99, 99, 99)
      opacity: 0.5
      cursor: default

  &:hover
    opacity: .8

  &+&
    margin-left: 2rem

/* Copyright */

.Copyright
  text-align: center
  font-size: 0.7em

  &, & a, & a:hover
    color: $gray-dark


@media (max-width: 868px)
  .Topnav
    padding-top:8px
    flex-direction: column
    .logo
      margin-right:0px
      img
        width:221px
    .inner
      margin-left: -16px

  h1, .f1
    font-size:3rem

  h2, .f3-l
    font-size:1.8rem

  p
    font-size:1rem!important

</style>



// WEBPACK FOOTER //
// App.vue?608913c2